export default function getRangeFacetsAsQueryString(args: {
  searchParams: URLSearchParams;
  value: { min: number; max: number } | { min: null; max: null };
}) {
  const { searchParams, value } = args;
  const newSearchParams = new URLSearchParams(searchParams.toString());

  if (value.min === null && value.max === null) {
    newSearchParams.delete('price');
  } else {
    newSearchParams.set('price', `${value.min}-${value.max}`);
  }

  return newSearchParams.toString();
}
